import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import PositionsSnippetError from './positions-snippet-error';
import {positionsSnippetMap} from 'components/organisms/late-swap/services/maps';

const PositionsSnippetFactory = {
    getSnippet(sportConfig): ArraySnippetInterface {
        const site = sportConfig.getSite().toLowerCase();
        const sport = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        try {
            return positionsSnippetMap[site][sport][gameType]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new PositionsSnippetError('Snippet is undefined');
            }
            throw e;
        }
    },
};

export default PositionsSnippetFactory;
